import axios from 'axios'
import { startRegistration, startAuthentication } from '@simplewebauthn/browser'
import { baseURL } from '../config'

export async function registerPasskey(friendlyName = 'My Passkey', reauthData = {}) {
	const optionsRes = await axios.post(`${baseURL}/api/user/passkey/register-options`, {
		...reauthData,
	})
	const options = optionsRes.data

	const attestation = await startRegistration({ optionsJSON: options })

	const verifyRes = await axios.post(`${baseURL}/api/user/passkey/register-verify`, {
		body: attestation,
		friendlyName,
	})

	return verifyRes.data
}

export async function loginWithPasskey(
	email,
	sourceExtension = false,
	userToken = null,
	extensionOnly = false
) {
	const optionsRes = await axios.post(`${baseURL}/api/users/passkey/login-options`, {
		email: email || undefined,
	})
	const options = optionsRes.data

	const assertion = await startAuthentication({ optionsJSON: options })

	const verifyRes = await axios.post(`${baseURL}/api/users/passkey/login-verify`, {
		body: assertion,
		source: sourceExtension ? 'extension' : undefined,
		token: userToken || undefined,
		extensionOnly,
	})

	return verifyRes.data
}

export async function listPasskeys() {
	const res = await axios.get(`${baseURL}/api/user/passkeys`)
	return res.data
}

export async function deletePasskey(credentialId, reauthData = {}) {
	const res = await axios.delete(`${baseURL}/api/user/passkey/${credentialId}`, {
		data: reauthData,
	})
	return res.data
}

export async function renamePasskey(credentialId, friendlyName) {
	const res = await axios.put(`${baseURL}/api/user/passkey/${credentialId}/rename`, {
		friendlyName,
	})
	return res.data
}
